import * as React from "react";
import { stylesheet } from "typestyle";

const css = stylesheet({
  label: {
    fontSize: 12,
    color: "#666666",
    textTransform: "uppercase",
    padding: "20px 16px 6px 16px",
    boxSizing: "border-box",
    width: "100%",
  },
});

interface IProps {
  label: string;
}

export default function SidebarLabel({ label }: IProps) {
  return <div className={css.label}>{label}</div>;
}
